import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useServiceRequest } from '../../../components/ServiceStatusProvider';

const CTASection = () => {
  const navigate = useNavigate();
  const { requestCleaning } = useServiceRequest();

  return (
    <div className="bg-card rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl p-8 sm:p-12 text-center">
      <div className="max-w-2xl mx-auto space-y-6">
        <div className="inline-flex items-center justify-center bg-blue-100 p-4 rounded-full mb-4">
          <Icon name="Sparkles" size={40} color="#2563EB" />
        </div>
        
        <h2 className="text-3xl sm:text-4xl font-bold text-foreground">
          지금 바로 시작하세요
        </h2>
        
        <p className="text-lg text-muted-foreground">
모든 케어는 1인 운영자의 직접
작업으로 진행됩니다.          <br />
정성스러운 손세탁과 비대면
수거·배송을 지금
이용해보세요        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
          <Button 
            variant="default" 
            size="lg"
            iconName="Calendar"
            iconPosition="right"
            onClick={() => requestCleaning()}
            className="bg-gradient-to-r from-blue-500 to-blue-600 text-white hover:from-blue-600 hover:to-blue-700 shadow-lg hover:shadow-xl focus:ring-2 focus:ring-blue-300"
          >
            세탁 서비스 신청하기
          </Button>
          
          <Button 
            variant="outline" 
            size="lg"
            iconName="Search"
            iconPosition="left"
            onClick={() => navigate('/order-status-tracking')}
            className="border-blue-500 text-blue-600 hover:bg-blue-600 hover:text-white transition-colors duration-200"
          >
            주문 조회하기
          </Button>
        </div>
        
        <div className="flex items-center justify-center gap-8 pt-6 text-sm text-muted-foreground">
          <div className="flex items-center gap-2">
            <Icon name="Truck" size={18} color="#2563EB" />
            <span>무료 픽업/배송</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Clock" size={18} color="#2563EB" />
            <span>3-5일 완료</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="ShieldCheck" size={18} color="#2563EB" />
            <span>품질 보증</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CTASection;